import { createToken, removeToken } from "../redux/auth";
import { loadUser } from "../redux/user";
import { axiosHandler } from "../utils/utils";

export const login = (data) => async (dispatch) => {
  try {
    verifyLogin(data);
    const json = await axiosHandler({
      url: `auth/login`,
      method: "POST",
      data,
    });
    await Promise.all([
      dispatch(createToken(json.data?.access_token)),
      dispatch(loadUser(json.data?.user)),
    ]);
  } catch (error) {
    await dispatch(removeToken());
    throw error;
  }
};

export const forgotPassword = (data) => async (dispatch) => {
  try {
    verifyEmail(data);
    const json = await axiosHandler({
      url: `auth/forgot-password`,
      method: "POST",
      data,
    });
    return json;
  } catch (error) {
    await dispatch(removeToken());
    throw error;
  }
};

export const resetPassword = (data) => async (dispatch) => {
  try {
    verifyPassword(data);
    const json = await axiosHandler({
      url: `auth/password`,
      method: "POST",
      data,
    });
    return json;
  } catch (error) {
    await dispatch(removeToken());
    throw error;
  }
};

export const setupPassword = (data) => async (dispatch) => {
  try {
    verifyPassword(data, true);
    const json = await axiosHandler({
      url: `auth/setup-password`,
      method: "POST",
      data,
    });
    if(json.data?.login_required){await dispatch(removeToken());return json;}
    await Promise.all([
      dispatch(createToken(json.data?.token)),
      dispatch(loadUser(json.data?.user)),
    ]);
    return json;
  } catch (error) {
    await dispatch(removeToken());
    throw error;
  }
};

// Validation Body
function verifyLogin(data) {
  const { email, password } = data;
  const errors = [];
  if (!email) errors.push("Email not provided");
  if (!password) errors.push("Password not provided");
  if (errors.length) throw Error(errors.join("\n"));
}

function verifyEmail(data) {
  const { email } = data;
  const errors = [];
  if (!email) errors.push("Email not provided");
}

function verifyPassword(data, isSetup = false) {
  const { password, confirmPassword } = data;
  const code = data.code;
  const token = data.token;
  
  const errors = [];
  
  // Check if password meets security requirements
  if (!password) errors.push("Password not provided");
  else {
    if (password.length < 8) errors.push("Password must be at least 8 characters");
    if (!/[A-Z]/.test(password)) errors.push("Password must contain at least one uppercase letter");
    if (!/[a-z]/.test(password)) errors.push("Password must contain at least one lowercase letter");
    if (!/[0-9]/.test(password)) errors.push("Password must contain at least one number");
  }
  
  if (!confirmPassword) errors.push("Confirm Password not provided");
  if (password !== confirmPassword) errors.push("Passwords do not match");
  
  // Check the appropriate token/code based on the action
  if (isSetup) {
    if (!token) errors.push("Setup Token Not Found");
  } else {
    if (!code) errors.push("Password Reset Code Not Found");
  }
  
  if (errors.length) throw Error(errors.join("\n"));
}
